import React from "react";

import "../../../adminAssets/css/style.css";
import "../../../adminAssets/css/style-preset.css";
import { Link } from "react-router-dom";


const AdminNav = () => {
    return(
    <>
    <nav className="pc-sidebar">
        <div className="navbar-wrapper">
            <div className="m-header">
                <a href="/" className="b-brand text-primary">
                    <img alt="" className="" style={{width:"105px;"}} src="/assets/images/logo/logo-iWant-Asia.png" />
                    <span className="d-block text-quicksand fw-bold text-main-one-600 text-16">Seller Center</span>
                </a>
            </div>
            <div className="navbar-content">
                <ul className="pc-navbar">
                        <li className="pc-item " id="products">
                            <Link to={"/admin/products"} className="pc-link">
                                <span className="pc-mtext">My Products</span>
                            </Link>
                        </li>
                       <li className="pc-item " id="storedecor">
                            <Link to={"/admin/store-decoration"} className="pc-link">
                                <span className="pc-mtext">Store Decoration</span>
                            </Link>
                        </li>
                    <li className="pc-item pc-hasmenu">
                        <a href="#!" className="pc-link">
                           <span className="pc-mtext">Wonder Kids</span><span className="pc-arrow"><i data-feather="chevron-down"></i></span>
                        </a>
                        <ul className="pc-submenu">
                            
                                <li className="pc-item" id="wkregistrationpage"><a className="pc-link" href="/wk-registration">Registration</a></li>
                                <li className="pc-item" id="wkstudentpage"><a className="pc-link" href="/wk-students">Students Group</a></li>
                                <li className="pc-item" id="studiopage"><a className="pc-link" href="/master-studio">Studio</a></li>
                                <li className="pc-item" id="publicclassteacherpage"><a className="pc-link" href="/master-teacher">Teacher</a></li>
                                <li className="pc-item" id="scheadulegrouppage"><a className="pc-link" href="/schedule-and-group">Schedule and Group</a></li>
                                <li className="pc-item" id="invoicepage"><a className="pc-link" href="/wk-invoices">Invoices</a></li>
                                <li className="pc-item " id="custominvoicepage"><a className="pc-link" href="/custom-invoice">Custom Invoice</a></li>
                            
                        </ul>
                    </li>
                    
                    <li className="pc-item pc-hasmenu">
                        <a href="#!" className="pc-link">
                           <span className="pc-mtext">E-Commerce</span><span className="pc-arrow"><i data-feather="chevron-down"></i></span>
                        </a>
                        <ul className="pc-submenu">

                            <li className="pc-item" id="invoicepage"><a className="pc-link" href="/ec-invoice">Invoices</a></li>
                            <li className="pc-item " id="studiobookingpage"><a className="pc-link" href="/studio-booking">Studio Bookings</a></li>
                            <li className="pc-item " id="classreservationpage"><a className="pc-link" href="/class-reservation">Class Reservation</a></li>
                           
                            <li className="pc-item" id="ecommercestudiorentpage"><a className="pc-link" href="/ecommerce-studio-rent">Studio Rent</a></li>
                            <li className="pc-item" id="ecommercemasterclasspage"><a className="pc-link" href="/ecommerce-master-class">Dance Class</a></li>
                           
                        </ul>
                    </li>
                    <li className="pc-item pc-hasmenu d-none">
                        <a href="#!" className="pc-link">
                            <span className="pc-micon"><i className="ti ti-man"></i></span><span className="pc-mtext">Settings</span><span className="pc-arrow"><i data-feather="chevron-down"></i></span>
                        </a>
                        <ul className="pc-submenu">
                            <li className="pc-item" id="wkpricesettingspage"><a className="pc-link" href="/wonderkids-price-settings">Wonder Kids Price</a></li>
                            <li className="pc-item" id="broadcastpage"><a className="pc-link" href="/broadcast">Broadcast</a></li>
                        </ul>
                    </li>


                   
                   
                    <li className="pc-item " id="composer">
                    <a href="/Composer" className="pc-link">
                    <span className="pc-micon">
                    <i cite="" className="fas fa-tag"></i>
                    </span>
                    <span className="pc-mtext">Composer</span>
                    </a>
                    </li>
                    


                </ul>
                <div className="w-100 text-center">

                    <div className="badge theme-version badge rounded-pill bg-light text-dark f-12"></div>
                </div>
            </div>
        </div>
    </nav>

    </>
    )
}

export default AdminNav;